import styled from 'styled-components'
import { Input } from '@sainsburys-tech/bolt'

const FulfilmentHeading = styled.p`
  margin: 0;
  position: relative;
  align-items: center;
  display: flex;
  gap: 4px;
`
const FulfilmentBox = styled.div`
  position: relative;
  margin-bottom: 0;
  background-color: ${props => props.theme.color.monochrome.white};
`

const InputContainer = styled(Input)`
  margin-bottom: 0px !important;
`

export { FulfilmentHeading, FulfilmentBox, InputContainer }
